import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { from } from 'rxjs'
import { getSavedStatuses } from 'services/compose/saved'
import { StoreThunkDispatch } from 'store/state'

interface FetchSavedTextsProps {
  force?: boolean
  onFetched?: (texts: any[]) => void
  onError?: (error: any) => void
}

export function FetchSavedTexts(props: FetchSavedTextsProps) {
  const dispatch = useDispatch<StoreThunkDispatch>()

  useEffect(() => {
    const sub = from(dispatch(getSavedStatuses(props.force)).unwrap())
      .subscribe(props.onFetched, props.onError)
    return () => sub.unsubscribe()
  }, [dispatch, props.force, props.onError, props.onFetched])

  return null
}
